import { Component, Inject, Input } from '@angular/core';

@Component({
  selector: 'prefs-component',
  template: `
      <div>
          <button class="btn btn-primary" (click)="reset()"><i class="fa fa-recycle"></i> <span>Reset All Data</span></button>
      </div>
      <div>
          <label for="restDelay">Simulated REST API delay (ms)</label>
          <input type="text" name="restDelay" [(ngModel)]="prefs.restDelay">
          <button class="btn btn-primary" (click)="savePrefs()">Save</button>
      </div>
  `,
})
export class PrefsComponent {
  prefs;
  @Input() user: any;

  constructor(@Inject('AppConfig') public AppConfig) { }

  ngOnInit() {
    this.prefs = {
      restDelay: this.AppConfig.restDelay
    }
    let u = this.user;
  }

  /** Clear out the session storage */
  reset() {
    sessionStorage.clear();
    document.location.reload();  // parameer no longer seems to be needed (true);
  }

  /** After saving preferences to session storage, reload the entire application */
  savePrefs() {
    Object.assign(this.AppConfig, { restDelay: this.prefs.restDelay }).save();
    document.location.reload();  // parameer no longer seems to be needed (true);
  }
}

